import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/ultimate/changelogs")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createChangelog = async (changelog) => {
  return await http
    .post("/ultimate/changelogs", changelog)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateChangelog = async (changelog) => {
  return await http
    .put(`/ultimate/changelogs/${changelog.id}`, changelog)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const aiRewriteChangelog = async (changelog) => {
  return await http
    .post("/ultimate/changelogs/ai-rewrite", changelog)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateChangelogImage = async (id, image) => {
  const formData = new FormData();
  formData.append("file", image);
  return await http
    .put(`/ultimate/changelogs/${id}/image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default { getAll, createChangelog, updateChangelog, aiRewriteChangelog, updateChangelogImage };
